import { render, staticRenderFns } from "./Peliculas.vue?vue&type=template&id=755255ef&"
import script from "./Peliculas.vue?vue&type=script&lang=js&"
export * from "./Peliculas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports